export default function faq() {
    document.querySelectorAll('.content-faq .faq-item__trigger').forEach((btn) => {
        btn.addEventListener('click', () => {
            const item = btn.closest('.faq-item')
            if (!item) return
            const open = !item.classList.contains('is-open')
            item.classList.toggle('is-open', open)
            btn.setAttribute('aria-expanded', String(open))
        })
    })
}
